<template>
    <div>
        <span class="label" :class="statusCss[status]">{{
            __(statusName)
        }}</span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            statusCss: {
                active: "label-primary",
                pending: "label-warning",
                archival: "label-default"
            }
        };
    },
    props: {
        status: {
            type: String,
            default: ""
        }
    },
    computed: {
        statusName() {
            return this.status == "active" ? "valid" : this.status;
        }
    }
};
</script>

<style lang="scss" scoped></style>
